var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.166504,
    height: 21.167358,
    viewBox: "0 0 21.1665 21.1674",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8.5 17C10.4868 17 12.314 16.3185 13.7612 15.1765L19.4595 20.8744C19.8496 21.265 20.4829 21.265 20.8735 20.8744C21.2642 20.4839 21.2642 19.8507 20.8735 19.4602L15.1758 13.7623C16.3184 12.3149 17 10.4871 17 8.5C17 3.80554 13.1943 0 8.5 0C3.80566 0 0 3.80554 0 8.5C0 13.1945 3.80566 17 8.5 17ZM8.5 15C10.2832 15 11.8984 14.282 13.0728 13.1194C13.0801 13.1116 13.0879 13.1039 13.0952 13.0963C13.103 13.0886 13.1108 13.0811 13.1187 13.0737C14.2817 11.8993 15 10.2836 15 8.5C15 4.91016 12.0898 2 8.5 2C4.91016 2 2 4.91016 2 8.5C2 12.0898 4.91016 15 8.5 15ZM8.5 3.25C7.94775 3.25 7.5 3.69775 7.5 4.25C7.5 4.80225 7.94775 5.25 8.5 5.25C10.2949 5.25 11.75 6.70508 11.75 8.5C11.75 9.05225 12.1978 9.5 12.75 9.5C13.3022 9.5 13.75 9.05225 13.75 8.5C13.75 5.60046 11.3994 3.25 8.5 3.25Z",
    clipRule: "evenodd",
    fill: "#50964E",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.ecc0cdc9249b12fb6b83ce58f8a574c7.svg";
export { ForwardRef as ReactComponent };